import { Component } from '@angular/core';

@Component({
  selector: 'bn-otp-error',
  templateUrl: 'banesco-otp-error.component.html',
})
export class BnOtPErrorComponent {}
